// hack to get fluid images to have a height in safari

// $('.fluid-container__image-wrap--match-height').each(function() {
//   var parent_height = $(this)
//     .parent()
//     .height();
//   $(this).css('height', parent_height);
// });
